const errorsNOTinToast =  [
  'send_postbacks_campaign_forbidden',
  'traffic_loss_campaign_forbidden',
  'uniqueness_period_forbidden',
  'double_meta_redirect_forbidden',
  'traffic_source_integration_forbidden',
  'traffic_source_param_masking_forbidden',
  'tags_campaigns_forbidden',
  'tags_offers_forbidden',
  'tags_landings_forbidden',
  'tags_flows_forbidden',
  'tags_traffic_sources_forbidden',
  'tags_affiliate_networks_forbidden',
  'visit_cap_condition_forbidden',
  'smart_rotation_forbidden',
  'double_meta_redirect_forbidden',
  'uniqueness_period_forbidden',
  'traffic_loss_campaign_forbidden',
  'send_postbacks_campaign_forbidden',
  'subscription_update_total_less_than_50_cents',
  'crawler_condition_forbidden',
  'referrer_domain_condition_forbidden',
  'uniqueness_period_condition_forbidden',
  'visit_cap_condition_forbidden',
  'proxy_condition_forbidden',
  'webview_condition_forbidden',
  'bot_mark_condition_forbidden'
]

export const showPlanLimitsErrorInToast = (error)=>{
  const errorInMessage = errorsNOTinToast.includes((error?.response?.data?.message).toLowerCase())
  const errorsAsString = JSON.stringify(error?.response?.data?.errors)?.toLowerCase();
  const errorInErrors = errorsAsString && errorsNOTinToast.find((item)=> errorsAsString.search(item))

  return (!errorInMessage && !errorInErrors)
}
